import { lazy } from 'react';
import Loadable from 'components/Loadable';

const PerformanceDashboard = Loadable(lazy(() => import('./components/performance-dashboard/PerformanceDashboard')));
const PerformanceReviews = Loadable(lazy(() => import('./components/performance-reviews/PerformanceReviews')));
const PerformanceGoals = Loadable(lazy(() => import('./components/performance-goals/PerformanceGoals')));
const PerformanceFeedback = Loadable(lazy(() => import('./components/performance-feedback/PerformanceFeedback')));
const PerformanceAppraisals = Loadable(lazy(() => import('./components/performance-appraisals/PerformanceAppraisals')));
const PerformanceReports = Loadable(lazy(() => import('./components/performance-reports/PerformanceReports')));
const PerformanceSettings = Loadable(lazy(() => import('./components/performance-settings/PerformanceSettings')));

export const performanceRoutes = {
  path: 'performance',
  children: [
    { index: true, element: <PerformanceDashboard /> },
    { path: 'dashboard', element: <PerformanceDashboard /> },
    { path: 'reviews', element: <PerformanceReviews /> },
    { path: 'goals', element: <PerformanceGoals /> },
    { path: 'feedback', element: <PerformanceFeedback /> },
    { path: 'appraisals', element: <PerformanceAppraisals /> },
    { path: 'reports', element: <PerformanceReports /> },
    { path: 'settings', element: <PerformanceSettings /> }
  ]
};

export default performanceRoutes;
